import { Component } from '@angular/core';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SuperAdminService } from '../super-admin.service';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { DumbAdmin } from '../DTOs/dumb-admin';
import { SaveAdminRequest } from '../DTOs/save-admin-request';
import { MemberUserManagementService } from '../../member-admin/member-user-management/member-user-management.service';

@Component({
    selector: 'app-add-edit-super-admin-modal',
    templateUrl: './add-edit-super-admin-modal.component.html',
    providers: [UIBlockingService]
})
export class AddEditSuperAdminModalComponent {
    constructor(private activeModal: NgbActiveModal,
        private fb: FormBuilder,
        private superAdminService: SuperAdminService,
        private memberAdminService: MemberUserManagementService,
        private notificationService: ToastNotificationService,
        private blockUI: UIBlockingService) { }


    firstNameCtrl = new FormControl("firstName", [Validators.required]);
    lastNameCtrl = new FormControl("lastName", [Validators.required]);
    emailAddressCtrl = new FormControl("emailAddress", [Validators.required, Validators.email]);
    isActiveCtrl = new FormControl("isActive", [Validators.required]);

    manageAdminForm: FormGroup = new FormGroup({
        firstName: this.firstNameCtrl,
        lastName: this.lastNameCtrl,
        emailAddress: this.emailAddressCtrl,
        isActive: this.isActiveCtrl
    });
    admin: DumbAdmin;
    headerText: string;
    adding: any;
    validationTriggered = false;
    isBusy = false;
    isMemberAdmin = false;
    hideStatusToggle = false;

    firstName() { return this.manageAdminForm.get('firstName').value }
    lastName() { return this.manageAdminForm.get('lastName').value }
    email() { return this.manageAdminForm.get('emailAddress').value }
    isActive() { return this.manageAdminForm.get('isActive').value }


    ngOnInit() {
        this.resetManageAdminForm();
    }

    private resetManageAdminForm(): void {
        this.manageAdminForm.reset();
        if (this.adding) {
            this.manageAdminForm.patchValue({
                firstName: '',
                lastName: '',
                emailAddress: '',
                isActive: true
            });
        }
        else {
            this.manageAdminForm.patchValue({
                firstName: this.admin.firstName,
                lastName: this.admin.lastName,
                emailAddress: this.admin.emailAddress,
                isActive: this.admin.isActive
            });
        }

    }
    dismiss(): void {
        this.activeModal.dismiss();
    }
    saveAdmin() {
        for (var i in this.manageAdminForm.controls) {
            this.manageAdminForm.controls[i].markAsTouched();
        }
        if (!this.manageAdminForm.valid) {
            return false;
        }

        this.blockUI.start();

        if (this.adding) {
            var request = new SaveAdminRequest(
                ""
                , this.firstName()
                , this.lastName()
                , this.email()
                , this.isActive()
            );
            if (this.isMemberAdmin) {
                this.memberAdminService.CreateNewMemberAdmin(request)
                    .subscribe({
                        next: (data) => {
                            console.log('Observable emitted the next value: ' + data);
                        },
                        error: (err) => {
                            console.error('Observable emitted an error: ' + err);
                            this.notificationService.error(err.error.message);
                            this.blockUI.stop();
                        },
                        complete: () => {
                            console.log('Observable emitted the complete notification');
                            this.blockUI.stop();
                            this.activeModal.close();
                        }
                    });
            }
            else {
                this.superAdminService.CreateNewSuperAdmin(request)
                    .subscribe({
                        next: (data) => {
                            console.log('Observable emitted the next value: ' + data);
                        },
                        error: (err) => {
                            console.error('Observable emitted an error: ' + err);
                            this.notificationService.error(err.error.message);
                            this.blockUI.stop();
                        },
                        complete: () => {
                            console.log('Observable emitted the complete notification');
                            this.blockUI.stop();
                            this.activeModal.close();
                        }
                    });
            }
        }
        else {
            var request = new SaveAdminRequest(
                this.admin.contactId
                , this.firstName()
                , this.lastName()
                , this.email()
                , this.isActive()
            );
            if (this.isMemberAdmin) {
                this.memberAdminService.UpdateMemberAdmin(request)
                    .subscribe({
                        next: (data) => {
                            console.log('Observable emitted the next value: ' + data);
                        },
                        error: (err) => {
                            console.error('Observable emitted an error: ' + err);
                            this.blockUI.stop();
                        },
                        complete: () => {
                            console.log('Observable emitted the complete notification');
                            this.blockUI.stop();
                            this.activeModal.close();
                        }
                    });
            }
            else {
                this.superAdminService.UpdateSuperAdmin(request)
                    .subscribe({
                        next: (data) => {
                            console.log('Observable emitted the next value: ' + data);
                        },
                        error: (err) => {
                            console.log(err)
                            this.notificationService.error(err.error.message);
                            this.blockUI.stop();
                        },
                        complete: () => {
                            console.log('Observable emitted the complete notification');
                            this.blockUI.stop();
                            this.activeModal.close();
                        }
                    });
            }
        }
        return true;
  }
}
